<template>
  <div class="register">
    <Header :pCtrl="false" />
    <div class="content">
      <div class="title">欢迎注册科云新零售账号</div>
      <div class="form__box">
        <div class="link__box">
          <span class="link__item">已有账号？</span>
          <span class="link__item link__item-active">立即登录</span>
        </div>
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item prop="uName">
            <el-input placeholder="账户名" v-model="form.uName">
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="cName">
            <el-input placeholder="请填写公司名称" v-model="form.cName">
              <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input
              placeholder="输入11位手机号"
              v-model="form.phone"
              maxlength="11"
            >
              <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="code">
            <div class="code__box">
              <div class="code">
                <el-input
                  placeholder="输入验证码"
                  v-model="form.code"
                ></el-input>
              </div>
              <div class="btn" @click="getCode">发送验证码</div>
            </div>
          </el-form-item> -->
        </el-form>
        <div class="submit__btn" @click="registering('form')">注册</div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Header from "@/components/Header";
import axios from "axios";
export default {
  name: "register",
  components: { Header },
  data() {
    let validatePhone = (rule, value, callback) => {
      if (!/^[1][0-9]{10}$/.test(value)) {
        callback(new Error("请输入11位手机号"));
      } else {
        callback();
      }
    };
    return {
      form: {
        uName: "",
        cName: "",
        phone: "",
        code: ""
      },
      rules: {
        uName: [
          { required: true, message: "请输入账户名", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 2 到 15 个字 ", trigger: "blur" }
        ],
        cName: [
          { required: true, message: "请输入请填写公司名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 2 到 15 个字 ", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入11位手机号", trigger: "blur" },
          {
            type: "number",
            message: "请输入11位手机号",
            trigger: ["blur", "change"],
            validator: validatePhone
          }
        ],
        code: [
          { required: true, message: "输入验证码", trigger: "blur" },
          { min: 3, max: 6, message: "输入有效验证码", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    getCode() {
      this.$message({
        message: "公司指定账号注册，请联系管理员",
        type: "warning"
      });
    },
    registering(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          axios({
            url: "http://show.keyunshop.com/oper_mng/txCtrl?txcode=com016",
            method: "post",
            data: {
              name: this.form.uName,
              tel: this.form.phone,
              company: this.form.cName
            }
          }).then(res => {
            // console.log(res);
            if (res.data.data.result_code == "1") {
              this.$message.success("注册成功！您可以去登录了");
              this.$refs[formName].resetFields();
            } else {
              this.$message.error(res.data.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  border-top: 1px solid rgba(41, 43, 58, 0.05);
  user-select: none;
  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 33px;
    color: rgba(62, 113, 255, 1);
    padding-top: 110px;
    padding-bottom: 40px;
    text-align: center;
  }
  .form__box {
    width: 400px;
    margin: 0 auto;
    .link__box {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-bottom: 10px;
      .link__item {
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(184, 186, 199, 1);
        cursor: pointer;
      }
      .link__item-active {
        color: rgba(41, 43, 58, 1);
        margin-left: 5px;
        cursor: pointer;
      }
    }
    .code__box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 214px;
      }
      .btn {
        width: 166px;
        height: 40px;
        line-height: 40px;
        background: rgba(62, 113, 255, 1);
        border-radius: 4px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;
      }
    }
    .submit__btn {
      height: 40px;
      line-height: 40px;
      background: rgba(62, 113, 255, 1);
      border-radius: 4px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
  }
}
</style>
<style>
.register /deep/ .el-input--small .el-input__inner {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}
.register /deep/ .el-input--small {
  font-size: 16px;
}
.register /deep/ .el-form-item--small .el-form-item__content,
.register /deep/ .el-form-item--small .el-form-item__label {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}
.register .el-form-item--mini.el-form-item,
.register .el-form-item--small.el-form-item {
  margin-bottom: 24px;
}
</style>
